import { useRef, useState } from 'react';
import { useInView } from '../../../hooks/useInView';

const videos = [
  {
    id: 1,
    src: 'https://storage.readdy-site.link/project_files/bc073682-be8a-41b0-bc42-811cad36305d/a939c663-f5a5-4521-8946-c2be419ca80e_WhatsApp-Video-2026-03-21-at-16.33.30.mp4?v=f7972b28c1f2e56718b7cfaf2de6dbf2',
    label: 'O Iluminador preferido das rainhas de bateria',
    description: 'A evoluçao dos iluminadores corporais',
  },
  {
    id: 2,
    src: 'https://storage.readdy-site.link/project_files/bc073682-be8a-41b0-bc42-811cad36305d/e157d1e0-c354-497e-abb3-fb18d8111b4e_WhatsApp-Video-2026-03-21-at-16.32.49.mp4?v=00d9e4c435322b3658fd658af5a0e10c',
    label: 'ilumine sua pele e hidrate ao mesmo tempo',
    description: 'Traga a energia do verao pra sua pele',
  },
];

function VideoCard({
  video,
  delay,
  inView,
}: {
  video: (typeof videos)[0];
  delay: string;
  inView: boolean;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);

  const togglePlay = () => {
    const el = videoRef.current;
    if (!el) return;
    if (el.paused) {
      el.play();
      setPlaying(true);
    } else {
      el.pause();
      setPlaying(false);
    }
  };

  return (
    <div
      className={`group relative rounded-2xl overflow-hidden border border-[#DFF0F0] bg-[#0A3D3D] ${
        inView ? `animate-fade-in-up ${delay}` : 'opacity-0-init'
      }`}
    >
      {/* Video */}
      <div className="relative aspect-video cursor-pointer" onClick={togglePlay} aria-label={video.label}>
        <video
          ref={videoRef}
          src={video.src}
          className="w-full h-full object-cover"
          playsInline
          onEnded={() => setPlaying(false)}
        />

        {/* Overlay play/pause */}
        {!playing && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/30 transition-all duration-300 group-hover:bg-black/40">
            <div className="w-16 h-16 flex items-center justify-center bg-[#0F7C7A] rounded-full transition-transform duration-300 group-hover:scale-110">
              <i className="ri-play-fill text-white text-2xl ml-1" />
            </div>
          </div>
        )}

        {/* Playing indicator */}
        {playing && (
          <div className="absolute top-3 right-3 bg-[#0F7C7A] text-white text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
            Reproduzindo
          </div>
        )}
      </div>

      {/* Card Info */}
      <div className="p-5 bg-white">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-1.5 h-1.5 rounded-full bg-[#0F7C7A]" />
          <span className="text-[#0F7C7A] text-xs font-semibold tracking-wider uppercase">
            {video.label}
          </span>
        </div>
        <p className="text-[#555555] text-sm leading-relaxed">{video.description}</p>
      </div>
    </div>
  );
}

export default function VideoSection() {
  const { ref, inView } = useInView();

  return (
    <section id="videos" className="py-24 bg-[#F5F5F5]">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className={`text-center mb-14 ${inView ? 'animate-fade-in-up' : 'opacity-0-init'}`}>
          <p className="text-[#0F7C7A] text-sm font-semibold tracking-[0.2em] uppercase mb-3">
            Conteúdo Exclusivo
          </p>
          <h2 className="font-display text-4xl lg:text-5xl text-[#1A1A1A] font-bold mb-4">
            Veja Nossa Marca{' '}
            <span className="italic text-[#0F7C7A]">em Ação</span>
          </h2>
          <p className="text-[#555555] text-base max-w-lg mx-auto leading-relaxed">
            Transparência e autenticidade são valores que vivemos todos os dias. Confira de perto nossa essência.
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {videos.map((video, idx) => (
            <VideoCard
              key={video.id}
              video={video}
              delay={idx === 0 ? '' : 'delay-200'}
              inView={inView}
            />
          ))}
        </div>

        {/* Bottom accent */}
        <div className={`mt-12 flex items-center justify-center gap-3 ${inView ? 'animate-fade-in-up delay-400' : 'opacity-0-init'}`}>
          <div className="h-px w-16 bg-[#0F7C7A]/30" />
          <span className="text-[#555555] text-sm">Feito com dedicação e paixão por cosméticos</span>
          <div className="h-px w-16 bg-[#0F7C7A]/30" />
        </div>
      </div>
    </section>
  );
}
